"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationRequiredError = void 0;
class AuthenticationRequiredError extends Error {
    constructor(message) {
        super(message);
        this.className = "AuthenticationRequiredError";
        this.message = "";
        this.message = message;
    }
}
exports.AuthenticationRequiredError = AuthenticationRequiredError;
//# sourceMappingURL=AuthenticationRequiredError.js.map